import { useMsal } from '@azure/msal-react';
import { ArrowRightStartOnRectangleIcon, Bars3Icon } from '@heroicons/react/24/outline';

import { initials, roleLabel } from '../auth/roles';
import { signOut } from '../auth/session';
import { usePrincipal } from '../auth/usePrincipal';
import { Badge } from './Badge';
import { Button } from './Button';
import { ThemeToggle } from './ThemeToggle';

export function Header({ onOpenMenu }: { onOpenMenu: () => void }) {
  const principal = usePrincipal();
  const { instance } = useMsal();

  return (
    <header className="flex shrink-0 items-center gap-3 border-b border-line bg-surface px-4 py-2.5 lg:px-6">
      <div className="lg:hidden">
        <Button variant="ghost" size="xs" aria-label="Open menu" onClick={onOpenMenu}>
          <Bars3Icon className="h-4 w-4" aria-hidden="true" />
        </Button>
      </div>
      <span className="font-semibold text-body lg:hidden">IRA</span>

      <div className="flex-1" />

      <ThemeToggle />

      <div className="flex items-center gap-2 border-l border-line pl-3">
        <div
          aria-hidden="true"
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand text-xs font-bold text-on-brand"
        >
          {initials(principal)}
        </div>
        <div className="hidden min-w-0 max-w-[12rem] xl:block">
          <p className="truncate text-xs font-medium text-body">
            {principal.name || principal.upn || 'Signed in'}
          </p>
          <p className="truncate text-[11px] text-subtle">{principal.upn}</p>
        </div>
        {/*
          The role is shown because it is the answer to "why can I not approve this" — the
          most common support question for a console with a role ladder. It is a label, not a
          control: the server re-derives it from the token on every request.
        */}
        <Badge tone="brand" title="Your Entra app role. The API enforces it on every request.">
          {roleLabel(principal.role)}
        </Badge>
        <Button
          variant="ghost"
          size="xs"
          aria-label="Sign out"
          title="Sign out"
          onClick={() => signOut(instance)}
        >
          <ArrowRightStartOnRectangleIcon className="h-4 w-4" aria-hidden="true" />
        </Button>
      </div>
    </header>
  );
}
